import React, { useState, useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import { RemoveRedEyeOutlined, SyncDisabled } from "@material-ui/icons";
import { VisibilityOffOutlined } from "@material-ui/icons";
import AlertMui from "../core/AlertMui";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import BackGroundLogoLogin from "../../assets/logo/Marca_TAS_Chile.png";

import AlertContext from "../../context/alert/alertContext";
import AuthContext from "../../context/authentication/authContext";

const useStyles = makeStyles((theme) => ({


  formTitle:{
    //styleName: poppins Medium14;
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "22px",
    letterSpacing: "0px",
    textAlign: "left",
    textColor:"#282828"

  },
  form: {
      width: "60%", // Fix IE 11 issue.
      marginTop: theme.spacing(1),
      justifyContent:'center',
      display:'flex',
      alignItems: "center",
    },
  submitButton: {
    fontFamily:'Poppins',
    fontStyle: 'normal',
    fontWeight:'400',
    fontSize:'16px', 
    lineHeight: '24px',
    color:"#ffffff",
    backgroundColor: "#001070",
    textTransform: 'capitalize',
    marginTop:"20px",
    padding: "14px, 49px, 14px, 49px",
    '&:hover': {
      backgroundColor: '#001070',
      transform: 'translateY(-1px) !important'},
      maxWidth:"460px"
    
  }
  ,
  title:{
  textAlign:'center'
  }
}));

const LoginForm = (props) => {
  const classess = useStyles();
  

  const alertContext = useContext(AlertContext);
  const { alert, showAlert } = alertContext;

  const authContext = useContext(AuthContext);
  const { authenticated, hasToChange, message, logIn, showLoginExpiredMessage} = authContext;

  useEffect(() => {
    if (authenticated && hasToChange === true) {
      window.location.href = "/app/change-password?show-terms-use=1";
    }

    if (authenticated && hasToChange === "true") {
      window.location.href = "/app/change-password?show-terms-use=1";
    }

    if (authenticated && hasToChange === false) {
      window.location.href = "/app/home";
      /* props.history.push("/app/portal"); */
    }

    if (authenticated && hasToChange === "false") {
      window.location.href = "/app/home";
      /* props.history.push("/app/portal"); */
    }

    if (message) {
      showAlert(message.msg, message.category);
    }
    if(showLoginExpiredMessage){
      showAlert('La sesión caducó. Por favor vuelva a loguearse', 'error');
    }
  }, [message, authenticated, props.history]);

  const { classes } = props;
  const [user, setUser] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const { username, password } = user;

  const onChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  //submit form
  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    //validate empty fields
    if (username.trim() === "" || password.trim() === "") {
      showAlert("Todos los campos son obligatorios.", "warning");
      setLoading(false);
      return;
    }

    const response = await logIn({ username, password });
    setLoading(response);
  };

  const [passwordType, setPasswordType] = useState("password");
  
  const togglePassword =()=>{
    if(passwordType==="password")
    {
     setPasswordType("text")
     return;
    }
    setPasswordType("password")
  }

  return (
  <div className={classes.form} >
    <form noValidate onSubmit={onSubmit} >
    
      <div className={classess.formTitle}>RUT</div>
      <TextField
        margin="dense"
        variant="outlined" 
        fullWidth
        id="username"
        // label="RUT"
        name="username"
        placeholder="Ingresa tu rut"
        autoComplete="username"
        defaultValue={''}
        autoFocus
        InputLabelProps={{ 
          style: { 
            borderColor:"#E8E9EA",
            backgroundColor:'white',
            color:'black',
            /* poppins Medium14 */
            fontFamily: 'Poppins',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '22px',
          }
        }}
        InputProps={{
          style: { 
            fontSize: "14px",
            backgroundColor:'white', 
            border:'#E8E9EA',
            borderRadius:'6px',
            marginBottom:"20px",
            maxWidth:"460px"
            }
        }}
        onChange={onChange}
       
      />
      <div className={useStyles.formTitle}>Contraseña</div>
      <TextField
        margin="dense"
        variant="outlined" 
        fullWidth
        name="password"
       // label="Contraseña"
        placeholder="Ingresa tu contraseña"
        type={passwordType}
        id="password"
        autoComplete="current-password"
        style={{ fontSize: "14px" , backgroundColor:'#ffffff' , borderColor:"#E8E9EA", borderRadius:"6px", maxWidth:"460px"}}
        InputLabelProps={{ style: { fontSize: "14px"} }}
        InputProps={{
          style: { fontSize: "14px"  },
          endAdornment: (
            <InputAdornment position="end">
              

              { passwordType == "password" &&
              <RemoveRedEyeOutlined
                onClick={togglePassword}
                style={{
                  color: "#949CA9",
                  cursor:"pointer"
                }}
              />
            }
            { passwordType == "text" &&
              <VisibilityOffOutlined
                onClick={togglePassword}
                style={{
                  color: "#949CA9",
                  cursor:"pointer"
                }}
              />
            }
            </InputAdornment>
          ),
        }}
        onChange={onChange}
      />
       <div style={{ display:"flex", justifyContent:"center", alignItems:"center", minWidth:"301px"}}>
        {loading ? (
          <CircularProgress />
        ) : (
          <Button
            type="submit"
            className={classess.submitButton}
            variant="contained"
            
            //color="primary"
            fullWidth
           // 
          >
            Ingresar
          </Button>
        )}</div>
     
      {alert && <AlertMui message={alert.msg} type={alert.category} />}
    </form>
    </div>
  );
};

export default withRouter(LoginForm);
